import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { PageHeading, SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import { getCopyText } from '../../states/selectors';
import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';
import { goToCOPPage, updateDetails } from '../../states/actions';
import { pages } from '../../../states/page/actions';
import CloseMatchDetails from './CloseMatchDetails';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

export class CloseMatch extends Component {
	constructor(props) {
		super(props);
		this.state = { checkingForMatch: false };

		this.handleUpdateDetails = this.handleUpdateDetails.bind(this);
	}

	handleUpdateDetails() {
		this.setState({ checkingForMatch: true });
		this.props.updateDetails().then(() => this.setState({ checkingForMatch: false }));
	}

	render() {
		const { copyText, content, goToCOPPage, handleCancel, setKeepAsIs } = this.props;
		const { heading, header_detail, footer_detail, footer } = copyText;
		const { cancelButtonText, updateButtonText, keepButtonText } = content;

		const updateButton = (
			<NavigationButton.Primary
				labelText={updateButtonText}
				onClick={this.handleUpdateDetails}
				data-test-id="cop-check-update-with-matching-details"
			/>
		);
		const keepAsIsButton = (
			<NavigationButton.Secondary
				labelText={keepButtonText}
				onClick={() => {
					setKeepAsIs(true);
					goToCOPPage(pages.COP.AccountWarning);
				}}
				data-test-id="cop-check-keep-as-is"
			/>
		);
		const cancelButton = <NavigationButton.Tertiary labelText={cancelButtonText} onClick={handleCancel} />;

		return (
			<ServicingSection>
				<LoadingLocalTakeover title="Loading" show={this.state.checkingForMatch}>
					<PageHeading data-test-id="close-match">{heading}</PageHeading>
					<p>{header_detail}</p>
					<CloseMatchDetails />
					<SubsectionHeading>{footer}</SubsectionHeading>
					<p>{footer_detail}</p>
					<NavigationButtonGroup
						primaryButton={updateButton}
						secondaryButtons={keepAsIsButton}
						tertiaryButtons={cancelButton}
					/>
				</LoadingLocalTakeover>
			</ServicingSection>
		);
	}
}

CloseMatch.propTypes = {
	content: PropTypes.shape({}),
	handleCancel: PropTypes.func,
	handleUpdateDetails: PropTypes.func,
	goToCOPPage: PropTypes.func.isRequired,
	copyText: PropTypes.shape({}),
};

const mapStateToProps = (state) => ({
	copyText: getCopyText(state),
});

const actionCreators = {
	updateDetails,
	goToCOPPage,
};

const connectWrapper = connect(mapStateToProps, actionCreators);
const contentWrapper = withContent({ content: copContent });

export default compose(connectWrapper, contentWrapper)(CloseMatch);
